<template>
  <div>
    <Head title="Work Order" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/work-orders/${workOrder.id}/boms`">
        Boms
      </Link>
      <span class="text-orange-400 font-medium">/</span>Edit
    </h1>
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden mb-3">
      <form @submit.prevent="update">
        <div class="pb-2 pr-6 w-full lg:w-full mb-8">
          <div class="flex flex-wrap -mb-16 -mr-6 p-8">
            <div class="pb-2 pr-6 w-full lg:w-8/12">
              <multiselect
                v-model="selectedInput"
                id="input_sku"
                placeholder="Search Input SKU"
                :options="inputSku"
                :close-on-select="true"
                :searchable="true"
                :error="form.errors.input_sku"
                :style= "form.errors.input_sku ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                @search-change="onSearchInputSkuChange"
                @input="onSelectedInputSku"
              />
              <div v-if="form.errors.input_sku" class="form-error">{{ form.errors.input_sku }}</div>
            </div>
            <div class="pb-2 pr-6 w-full lg:w-4/12">
              <text-input
                class="w-full lg:w-full"
                v-model="form.input_quantity"
                :error="form.errors.input_quantity"
                placeholder="Input Quantity"
              />
            </div>
          </div>
        </div>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button :loading="form.processing" class="btn-orange" type="submit">
            Update Bom
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'
import throttle from 'lodash/throttle'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    filters: Object,
    skus: {
      type: Array,
      default: () => []
    },
    inputSku: {
      type: Array,
      default: () => []
    },
    workOrder: Object,
    bom: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        part_number: this.part_number,
        description: this.description,
        input_quantity: this.bom.input_quantity,
        sku_id: this.bom.sku_id,
        input_sku: this.bom.input_sku,
      }),
      selectedInput: this.bom.input_sku,
    }
  },
  methods: {
    update() {
      this.form.post(`/work-orders/${this.workOrder.id}/boms/${this.bom.id}`, {
        onSuccess: () => {
          this.form.reset(
            'input_sku',
            'input_quantity',
          )
        }
      })
    },
    onSearchInputSkuChange: throttle(function (searchInputSku) {
        this.$inertia.get(`/work-orders/${this.workOrder.id}/boms/${this.bom.id}/edit`, {searchInputSku}, {
          preserveState: true,
          preserveScroll: true,
          replace: true
        })
      }, 200),
    onSelectedInputSku(inputSku, id) {
      this.form.input_sku = inputSku;
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>